import React, { useState, useEffect } from "react";
// import logo from "../assets/home/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import logo from "../Assets/white.png";

function Navbar2() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolling, setScrolling] = useState(false);
  const [user, setUser] = useState(null);
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolling(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  function handleDropdown() {
    setMenuOpen(!menuOpen);
  }

  //  Check if user is logged in
  useEffect(() => {
    const storedUser = localStorage.getItem("GISUL_USER");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  //  Logout Function
  const handleLogout = () => {
    localStorage.removeItem("GISUL_USER");
    localStorage.removeItem("GISUL_TOKEN");
    setUser(null);
    navigate("/login");
  };
  return (
    <>
      <nav
        className={`flex z-50 fixed top-0 justify-between w-full items-center xl:pl-[80px] lg:pl-[40px] pl-[20px] xl:pr-[60px] lg:pr-[160px] pr-[20px] py-[10px] transition-all duration-300  ${
          scrolling
            ? "bg-white/20 backdrop-blur-md shadow-lg"
            : "bg-transparent"
        }`}
      >
        <div
          className="overlay"
          onClick={handleDropdown}
          style={menuOpen ? { right: 0 } : { right: "100%" }}
        ></div>
        <div>
          <Link to="/">
            <img src={logo} className="sm:h-auto h-[29px]" alt="Logo" />
          </Link>
        </div>
        <ul className="white-text">
          <Link className="none">
            <div class="relative group">
              <button class="text-[#FFFFFF] font-[400] inline-flex font-sans text-[16px] leading-[20px] items-center">
                <span>GISUL Community</span>
                <svg class="fill-current h-4 w-4 ml-1" viewBox="0 0 20 20">
                  <path d="M5.516 7.548L10 12.032l4.484-4.484L16 9.064 10 15.064 4 9.064z" />
                </svg>
              </button>
              <ul class="absolute hidden group-hover:block bg-white border rounded-md shadow-md w-40 z-50">
                <li>
                  <Link
                    to="/dive-our"
                    class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    Community
                  </Link>
                </li>
                <li>
                  <Link
                    to="/our-media"
                    class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    Our Media
                  </Link>
                </li>
                <li>
                  <Link
                    to="/our-gallery"
                    class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    Our Gallery
                  </Link>
                </li>
                <li>
                  <Link
                    to="/our-work"
                    class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    Our Work
                  </Link>
                </li>
                <li>
                  <Link
                    to="/our-awards"
                    class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    Our Awards
                  </Link>
                </li>
                <li>
                  <Link
                    to="/what-client"
                    class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    What Client
                  </Link>
                </li>
              </ul>
            </div>
          </Link>

          <Link className="none" to="/MastermindsHQ">
            {/* <li>GISUL Community</li> */}
            <li>Masterminds HQ</li>
          </Link>

          <Link className="none" to="/BondedBrilliance">
            <li >
              Bonded Brilliance
            </li>
          </Link>

          <Link className="none">
            <li>Who We Be</li>
          </Link>
          {/* <Link className="none" to="/cart">
         <li>Cart</li>
       </Link>
       <Link className="none" to="/wishlist">
         <li>Wishlist</li>
       </Link> */}
          <Link className="none" to="/SayHello">
            <li>Say Hello</li>
          </Link>
          <Link className="none">
            {/* <li>Leadership</li> */}
            <div class="relative group">
              <button class="text-[#FFFFFF] font-[400] inline-flex font-sans text-[16px] leading-[20px] items-center">
                <span>About</span>
                <svg class="fill-current h-4 w-4 ml-1" viewBox="0 0 20 20">
                  <path d="M5.516 7.548L10 12.032l4.484-4.484L16 9.064 10 15.064 4 9.064z" />
                </svg>
              </button>
              <ul class="absolute hidden group-hover:block bg-white border rounded-md shadow-md w-40 z-50">
                <li>
                  <Link
                    to="/services"
                    class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                  >
                    Services
                  </Link>
                </li>
              </ul>
            </div>
          </Link>
        </ul>
        <div className="nav-btn">
          <Link to="/course">
            <button className="px-[32px] font-sans py-[16px] rounded-md bg-[#f1e60d] text-black text-sm transition-colors duration-300 ease-in-out hover:bg-[#6953a3] hover:text-white">
              Courses<i className="bi bi-arrow-right"></i>
            </button>
          </Link>

          {user ? (
            <div
              className="relative flex items-center cursor-pointer"
              onMouseEnter={() => setShowLogout(true)}
              onMouseLeave={() => setShowLogout(false)}
            >
              <Link to="/profile">
                <button className="px-[32px] py-[16px] rounded-md bg-[#f1e60d] text-black text-sm transition-colors duration-300 ease-in-out hover:bg-[#6953a3] hover:text-white">
                  {/* <img src="/assets/profile-icon.svg" alt="Profile" className="h-6 w-6 rounded-full" /> */}
                  <i className="bi bi-person-fill"></i>{" "}
                  <span className="ml-2">{user.name.split(" ")[0]}</span>
                </button>
              </Link>

              {/* {showLogout && (
                <div
                  className="absolute top-12 font-sans right-0 bg-white border rounded shadow-md px-4 py-2 text-red-600 cursor-pointer"
                  onClick={handleLogout}
                >
                  Logout
                </div>
              )} */}
            </div>
          ) : (
            <Link to="/login">
              <button className="px-[32px] py-[16px] font-sans rounded-md bg-[#f1e60d] text-black text-sm transition-colors duration-300 ease-in-out hover:bg-[#6953a3] hover:text-white">
                Login<i className="bi bi-arrow-right"></i>
              </button>
            </Link>
          )}
          {user && (
            <Link to="/cart" className="py-[16px] ">
              <i className="fa fa-shopping-cart" aria-hidden="true"></i>
            </Link>
          )}

          {/* <Link to="/login">
         <button className="btn">
           Login <span className="arrow"></span>
         </button>
       </Link> */}
        </div>

        <div className="list" onClick={() => setMenuOpen(!menuOpen)}>
          <i className="bi bi-list-nested"></i>
        </div>
      </nav>
      <div
        className={`flex lg:relative navbar-item fixed lg:w-auto w-[325px] lg:bg-transparent bg-[#FFFFFF] lg:flex-row lg:items-center items-start lg:pt-0 pt-[30px] h-[583px] flex-col lg:gap-[30px] gap-[20px] top-0 bottom-0 ${
          menuOpen ? "right-0" : "right-[-325px]"
        }`}
      >
        <ul>
          <div className="flex justify-between pb-[20px] px-[20px]">
            <Link to="/">
              <img
                src="/assets/home/logo.svg"
                className="h-[29px]"
                alt="Logo"
              />
            </Link>
            <button onClick={() => setMenuOpen(!menuOpen)}>
              <img src="/assets/home/close.svg" alt="" />
            </button>
          </div>
          <Link className="none">
            <li className="border-y-[1px] border-[#CCCCCC] px-[20px] py-[15px] font-[400] text-[16px] leading-[20px] text-[#3A3A3A] font-sans">
              <div class="relative group">
                <button class="text-[#3A3A3A] font-[400] inline-flex font-sans text-[16px] leading-[20px] items-center">
                  <span>GISUL Community</span>
                  <svg class="fill-current h-4 w-4 ml-1" viewBox="0 0 20 20">
                    <path d="M5.516 7.548L10 12.032l4.484-4.484L16 9.064 10 15.064 4 9.064z" />
                  </svg>
                </button>
                <ul class="absolute hidden group-hover:block bg-white border rounded-md shadow-md w-40 z-50">
                  <li>
                    <Link
                      to="/dive-our"
                      class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                    >
                      Community
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/our-media"
                      class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                    >
                      Our Media
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/our-gallery"
                      class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                    >
                      Our Gallery
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/our-work"
                      class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                    >
                      Our Work
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/our-awards"
                      class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                    >
                      Our Awards
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/what-client"
                      class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                    >
                      What Client
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
          </Link>
          <Link className="none">
            {/* <li>Leadership</li> */}
            <li className="border-y-[1px] border-[#CCCCCC] px-[20px] py-[15px] font-[400] text-[16px] leading-[20px] text-[#3A3A3A] font-sans">
              <div class="relative group">
                <button class="text-[#3a3a3a] font-[400] inline-flex font-sans text-[16px] leading-[20px] items-center">
                  <span>About</span>
                  <svg class="fill-current h-4 w-4 ml-1" viewBox="0 0 20 20">
                    <path d="M5.516 7.548L10 12.032l4.484-4.484L16 9.064 10 15.064 4 9.064z" />
                  </svg>
                </button>
                <ul class="absolute hidden group-hover:block bg-white border rounded-md shadow-md w-40 z-50">
                  <li>
                    <Link
                      to="/services"
                      class="block px-4 py-2 text-gray-800 hover:bg-gray-100"
                    >
                      Services
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
          </Link>
          <Link className="none" to="/MastermindsHQ">
            <li
              className="border-y-[1px] border-[#CCCCCC] px-[20px] py-[15px] font-[400] text-[16px] leading-[20px] text-[#3A3A3A]"
              style={{ fontFamily: "DM Sans, serif" }}
            >
              {/* GISUL Community */}
              Masterminds HQ
            </li>
          </Link>
          <Link className="none" to="/BondedBrilliance">
            <li
              className="border-y-[1px] border-[#CCCCCC] px-[20px] py-[15px] font-[400] text-[16px] leading-[20px] text-[#3A3A3A]"
              style={{ fontFamily: "DM Sans, serif" }}
            >
              Bonded Brilliance
            </li>
          </Link>
          <Link className="none" to="/WhoWeBe">
            <li
              className="border-y-[1px] border-[#CCCCCC] px-[20px] py-[15px] font-[400] text-[16px] leading-[20px] text-[#3A3A3A]"
              style={{ fontFamily: "DM Sans, serif" }}
            >
               Who We Be
            </li>
          </Link>
          <Link className="none" to="/cart">
            <li
              className="border-y-[1px] border-[#CCCCCC] px-[20px] py-[15px] font-[400] text-[16px] leading-[20px] text-[#3A3A3A]"
              style={{ fontFamily: "DM Sans, serif" }}
            >
              Cart
            </li>
          </Link>
          <div className="flex flex-col mt-[38px] gap-[14px] px-[20px]">
            <Link className="none" to="/SayHello">
              <button
                style={{ width: "100%" }}
                className="px-[32px] py-[16px] rounded-md bg-[#f1e60d] text-black text-sm transition-colors duration-300 ease-in-out hover:bg-[#6953a3] hover:text-white"
              >
                Say Hello <span className="arrow"></span>
              </button>
            </Link>
            <Link className="none" to="/course">
              <button
                style={{ width: "100%" }}
                className="px-[32px] py-[16px] rounded-md bg-[#f1e60d] text-black text-sm transition-colors duration-300 ease-in-out hover:bg-[#6953a3] hover:text-white"
              >
                Courses <span className="arrow"></span>
              </button>
            </Link>
            {user ? (
              <div
                className="relative flex items-center cursor-pointer "
                style={{ gap: "10px" }}
                onMouseEnter={() => setShowLogout(true)}
                onMouseLeave={() => setShowLogout(false)}
              >
                <Link to="/profile">
                  <button
                    style={{ width: "100%" }}
                    className="px-[32px] py-[16px] rounded-md bg-[#f1e60d] text-black text-sm transition-colors duration-300 ease-in-out hover:bg-[#6953a3] hover:text-white"
                  >
                    {/* <img src="/assets/profile-icon.svg" alt="Profile" className="h-6 w-6 rounded-full" /> */}
                    <span className="ml-2">{user.name.split(" ")[0]}</span>
                  </button>
                </Link>

                <br />
                <button
                  style={{ width: "100%" }}
                  className="px-[32px] py-[16px] rounded-md bg-[#f1e60d] text-black text-sm transition-colors duration-300 ease-in-out hover:bg-[#6953a3] hover:text-white"
                  onClick={handleLogout}
                >
                  Logout
                </button>

                {/* {showLogout && (
             <div
               className="absolute top-12 right-0 bg-white border rounded shadow-md px-4 py-2 text-red-600 cursor-pointer"
               onClick={handleLogout}
             >
               Logout
             </div>
           )} */}
              </div>
            ) : (
              <Link to="/login">
                <button
                  style={{ width: "100%" }}
                  className="px-[32px] py-[16px] rounded-md bg-[#f1e60d] text-black text-sm font-[DM Sans] transition-colors duration-300 ease-in-out hover:bg-[#6953a3] hover:text-white"
                >
                  Login
                </button>
              </Link>
            )}
          </div>
        </ul>
      </div>
      {/* {menuOpen && (
     <div className="toggle-menu">
       <ul>
         <div className="logo"></div>
         <Link className="none" to="/partner">
           <li>GISUL Community</li>
         </Link>
         <Link className="none" to="/partner">
           <li>About Us</li>
         </Link>
         <Link className="none" to="/partner">
           <li>Leadership</li>
         </Link>
         <Link className="none" to="/cart">
           <li>Cart</li>
         </Link>
         <Link className="none" to="/SayHello">
           <li>Talk To Us</li>
         </Link>
         <br />
         <Link className="none" to="/partner">
           <button>Courses</button>
         </Link>

         <Link className="none" to="/login">
           <button>Login</button>
         </Link>
       </ul>
     </div>
   )} */}
    </>
  );
}

export default Navbar2;
